export const CHAT_ASSISTANT_ID = 'CHAT_ASSISTANT_ID'
export const PRIVACY_POLICY_PAGE_PATHNAME = '/privacy-policy'
